import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Supervisor } from '../../../features/users/users.model';

@Component({
  selector: 'app-supervisor-picker',
  standalone: false,
  templateUrl: './supervisor-picker.component.html',
  styleUrl: './supervisor-picker.component.scss'
})
export class SupervisorPickerComponent {
  @Input() supervisor: Supervisor | null = null;
  @Input() hasError: boolean = false;
  @Input() disabled: boolean = false;
  @Input() disabledMessage: string = '';
  @Output() supervisorChange = new EventEmitter<Supervisor | null>();
  @Output() pickSupervisor = new EventEmitter<void>();

  onPick(): void {
    if (!this.disabled) {
      this.pickSupervisor.emit();
    }
  }

}
